// Do not edit manually

export const IMAGES = {
  COMMERCIAL_BUILDING_4: "https://images.unsplash.com/photo-1766524555230-3071d08571f0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4MTk0NTh8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwcmVhbCUyMGVzdGF0ZSUyMG9mZmljZSUyMGJ1aWxkaW5nJTIwS29yZWF8ZW58MHwwfHx8MTc3NzA5ODc2NHww&ixlib=rb-4.1.0&q=80&w=1080",
  CONTRACT_SIGNING_8: "https://images.unsplash.com/photo-1769038947088-62455c949efc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDU5NTF8MHwxfHNlYXJjaHw0fHxyZWFsJTIwZXN0YXRlJTIwY29udHJhY3QlMjBzaWduaW5nJTIwYnVzaW5lc3N8ZW58MHwwfHx8MTc3NzA5ODc2NXww&ixlib=rb-4.1.0&q=80&w=1080",
  PROFILE_1_NOBG: "/images/profile_1_nobg.png",
  PROFILE_2_NOBG: "/images/profile_2_nobg.png",
  PROFILE_3_NOBG: "/images/profile_3_nobg.png",
} as const;

export type ImageKey = keyof typeof IMAGES;
